import { toast } from "react-toastify";
import { sendPurchaseOperationData } from "../../../apis/apis.logistics/apisProduct";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export function ReceiveOrderPurchaseList({
    order,
    setOrder,
    initialOrderState,
}) {
    const sendPurchase = async () => {
        try {
            const orderToSend = {
                ...order,
                affectsStock:
                    order.affectsStock === "true" ||
                    order.affectsStock === true,
            };
            console.log(orderToSend);
            const response = await sendPurchaseOperationData(orderToSend);
            return response;
        } catch (error) {
            throw error;
        }
    };
    const navigate = useNavigate();

    const inputClass =
        "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors disabled:opacity-50 disabled:cursor-not-allowed";

    const calculateSubtotal = (item, qty) => {
        return (
            Number(qty) * Number(item.price) -
            (Number(qty) * Number(item.price) * item.percentageDiscount) / 100
        );
    };

    const totalOrdered = Number(
        order.operationItems.reduce(
            (prev, curr) => prev + Number(curr.amountIgv),
            0,
        ),
    ).toFixed(2);

    const totalReceived = Number(
        order.operationItems.reduce(
            (prev, curr) => prev + calculateSubtotal(curr, curr.quantity),
            0,
        ),
    ).toFixed(2);

    const totalMissing = Number(
        order.operationItems.reduce((prev, curr) => {
            const missingQty =
                Number(curr.quantityOrdered) -
                Number(curr.quantityReceived) -
                Number(curr.quantity);
            return prev + calculateSubtotal(curr, missingQty);
        }, 0),
    ).toFixed(2);

    const handleSubmit = async () => {
        if (order.operationItems.length) {
            const found = order.operationItems.find(
                (detail) => detail.condition == "02",
            );
            if (found) {
                if (order.warehouseID != "0") {
                    if (order.operationDocumentNumber != "") {
                        if (order.operationDate != "") {
                            Swal.fire({
                                title: "¿Está usted seguro?",
                                text: "¿Generar la compra?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3b82f6",
                                cancelButtonColor: "#6b7280",
                                confirmButtonText: "Sí, generar",
                                cancelButtonText: "Cancelar",
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    sendPurchase()
                                        .then((r) => {
                                            if (r.status == 201) {
                                                toast.success(
                                                    "Compra realizada con exito!",
                                                );
                                                navigate(
                                                    "/buys/purchase_orders_issued",
                                                );
                                            } else {
                                                toast.error(
                                                    "Ocurrio algun error",
                                                );
                                            }
                                        })
                                        .then(() => {
                                            setOrder(initialOrderState);
                                        });
                                }
                            });
                        } else {
                            toast.error("Verifique la fecha");
                        }
                    } else {
                        toast.error("Verifique el numero de documento");
                    }
                } else {
                    toast.error("Verifique el almacen");
                }
            } else {
                toast.error("No hay nada por recibir");
            }
        } else {
            toast.error("Verifique los items a registrar");
        }
    };

    return (
        <>
            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden mb-6">
                {/* Desktop View - Table */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="w-full text-sm text-left">
                        <thead className="bg-gray-900 text-gray-100">
                            <tr>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                                    #
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                                    SKU
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                                    Producto
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                                    Unidad
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide text-right">
                                    Precio
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                                    Cant. Ordenada
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                                    Cant. Recibida
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                                    Cant. Faltante
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide text-right">
                                    Subtotal Ordenado
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide text-right">
                                    Subtotal Recibido
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide text-right">
                                    Subtotal Faltante
                                </th>
                                <th className="px-4 py-3 text-center text-xs font-semibold uppercase tracking-wide">
                                    Fec. Vto
                                </th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                            {order.operationItems.map((item, index) => {
                                const missingQty =
                                    Number(item.quantityOrdered) -
                                    Number(item.quantityReceived) -
                                    Number(item.quantity);
                                return (
                                    <tr
                                        key={index}
                                        className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                                    >
                                        <td className="px-4 py-3">
                                            <div className="flex items-center gap-2">
                                                <input
                                                    type="checkbox"
                                                    name="condition"
                                                    id={
                                                        "condition" +
                                                        item.operationDetailID
                                                    }
                                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 disabled:opacity-50"
                                                    checked={
                                                        item.condition ==
                                                            "02" ||
                                                        item.condition == "03"
                                                            ? true
                                                            : false
                                                    }
                                                    disabled={
                                                        item.condition == "03"
                                                            ? true
                                                            : false
                                                    }
                                                    onChange={(e) => {
                                                        if (
                                                            Number(
                                                                item.quantity,
                                                            ) > 0
                                                        ) {
                                                            setOrder({
                                                                ...order,
                                                                operationItems:
                                                                    order.operationItems.map(
                                                                        (
                                                                            obj,
                                                                        ) => {
                                                                            if (
                                                                                obj.operationDetailID ==
                                                                                item.operationDetailID
                                                                            ) {
                                                                                if (
                                                                                    obj.condition ==
                                                                                    "01"
                                                                                )
                                                                                    obj.condition =
                                                                                        "02";
                                                                                else {
                                                                                    obj.condition =
                                                                                        "01";
                                                                                    obj.quantity =
                                                                                        "";
                                                                                }
                                                                            }
                                                                            return obj;
                                                                        },
                                                                    ),
                                                            });
                                                        }
                                                    }}
                                                />
                                                <label
                                                    htmlFor={
                                                        "condition" +
                                                        item.operationDetailID
                                                    }
                                                    className="text-xs font-medium text-gray-700 dark:text-gray-300"
                                                >
                                                    {item.condition == "01"
                                                        ? ""
                                                        : item.condition == "02"
                                                          ? "RECIBIDO"
                                                          : "GENERADO"}
                                                </label>
                                            </div>
                                        </td>
                                        <td className="px-4 py-3 text-center text-gray-900 dark:text-white">
                                            {item.sku}
                                        </td>
                                        <td className="px-4 py-3 text-left text-gray-900 dark:text-white">
                                            {item.productName}
                                        </td>
                                        <td className="px-4 py-3 text-center text-gray-600 dark:text-gray-400">
                                            {item.unitName}
                                        </td>
                                        <td className="px-4 py-3 text-right text-gray-900 dark:text-white">
                                            {Number(item.price)}
                                        </td>
                                        <td className="px-4 py-3 text-center text-gray-900 dark:text-white">
                                            {item.quantityOrdered}
                                        </td>
                                        <td className="px-4 py-3 text-center">
                                            <input
                                                type="number"
                                                className={`${inputClass} text-center`}
                                                name="quantity"
                                                onFocus={(e) =>
                                                    e.target.select()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                autoComplete="off"
                                                readOnly={
                                                    item.condition == "03"
                                                        ? true
                                                        : false
                                                }
                                                value={item.quantity}
                                                onChange={(e) => {
                                                    if (
                                                        Number(e.target.value) >
                                                        Number(
                                                            item.quantityOrdered,
                                                        ) -
                                                            Number(
                                                                item.quantityReceived,
                                                            )
                                                    ) {
                                                        return false;
                                                    } else if (
                                                        Number(
                                                            e.target.value,
                                                        ) == 0
                                                    ) {
                                                        setOrder({
                                                            ...order,
                                                            operationItems:
                                                                order.operationItems.map(
                                                                    (o) => {
                                                                        if (
                                                                            o.operationDetailID ==
                                                                            item.operationDetailID
                                                                        ) {
                                                                            o.quantity =
                                                                                e.target.value;
                                                                            o.condition =
                                                                                "01";
                                                                        }
                                                                        return o;
                                                                    },
                                                                ),
                                                        });
                                                    } else {
                                                        setOrder({
                                                            ...order,
                                                            operationItems:
                                                                order.operationItems.map(
                                                                    (o) => {
                                                                        if (
                                                                            o.operationDetailID ==
                                                                            item.operationDetailID
                                                                        ) {
                                                                            o.quantity =
                                                                                e.target.value;
                                                                            o.condition =
                                                                                "02";
                                                                        }
                                                                        return o;
                                                                    },
                                                                ),
                                                        });
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td className="px-4 py-3 text-center text-gray-900 dark:text-white">
                                            {Number(item.quantityReceived)}
                                        </td>
                                        <td className="px-4 py-3 text-right text-gray-900 dark:text-white">
                                            S/{" "}
                                            {Number(item.amountIgv).toFixed(2)}
                                        </td>
                                        <td className="px-4 py-3 text-right text-gray-900 dark:text-white font-medium">
                                            S/{" "}
                                            {calculateSubtotal(
                                                item,
                                                item.quantity,
                                            ).toFixed(2)}
                                        </td>
                                        <td className="px-4 py-3 text-right text-gray-900 dark:text-white font-medium">
                                            S/{" "}
                                            {calculateSubtotal(
                                                item,
                                                missingQty,
                                            ).toFixed(2)}
                                        </td>
                                        <td className="px-4 py-3">
                                            <input
                                                type="date"
                                                name="expireDate"
                                                className={inputClass}
                                                value={item.expireDate}
                                                onChange={(e) => {
                                                    setOrder({
                                                        ...order,
                                                        operationItems:
                                                            order.operationItems.map(
                                                                (o) => {
                                                                    if (
                                                                        o.operationDetailID ==
                                                                        item.operationDetailID
                                                                    ) {
                                                                        o.expireDate =
                                                                            e.target.value;
                                                                    }
                                                                    return o;
                                                                },
                                                            ),
                                                    });
                                                }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot className="bg-gray-50 dark:bg-gray-700/50">
                            <tr>
                                <td
                                    colSpan={8}
                                    className="px-4 py-3 text-right font-bold text-gray-900 dark:text-white"
                                >
                                    TOTAL
                                </td>
                                <td className="px-4 py-3 text-right font-bold text-gray-900 dark:text-white">
                                    S/ {totalOrdered}
                                </td>
                                <td className="px-4 py-3 text-right font-bold text-gray-900 dark:text-white">
                                    S/ {totalReceived}
                                </td>
                                <td className="px-4 py-3 text-right font-bold text-gray-900 dark:text-white">
                                    S/ {totalMissing}
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                {/* Mobile View - Cards */}
                <div className="md:hidden">
                    {order.operationItems.map((item, index) => {
                        const missingQty =
                            Number(item.quantityOrdered) -
                            Number(item.quantityReceived) -
                            Number(item.quantity);
                        return (
                            <div
                                key={index}
                                className="p-4 border-b border-gray-200 dark:border-gray-700 last:border-b-0"
                            >
                                <div className="flex items-center gap-2 mb-3">
                                    <input
                                        type="checkbox"
                                        name="condition"
                                        id={
                                            "condition-mobile" +
                                            item.operationDetailID
                                        }
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:bg-gray-700 disabled:opacity-50"
                                        checked={
                                            item.condition == "02" ||
                                            item.condition == "03"
                                                ? true
                                                : false
                                        }
                                        disabled={
                                            item.condition == "03"
                                                ? true
                                                : false
                                        }
                                        onChange={(e) => {
                                            if (Number(item.quantity) > 0) {
                                                setOrder({
                                                    ...order,
                                                    operationItems:
                                                        order.operationItems.map(
                                                            (obj) => {
                                                                if (
                                                                    obj.operationDetailID ==
                                                                    item.operationDetailID
                                                                ) {
                                                                    if (
                                                                        obj.condition ==
                                                                        "01"
                                                                    )
                                                                        obj.condition =
                                                                            "02";
                                                                    else {
                                                                        obj.condition =
                                                                            "01";
                                                                        obj.quantity =
                                                                            "";
                                                                    }
                                                                }
                                                                return obj;
                                                            },
                                                        ),
                                                });
                                            }
                                        }}
                                    />
                                    <label
                                        htmlFor={
                                            "condition-mobile" +
                                            item.operationDetailID
                                        }
                                        className="text-xs font-medium text-gray-700 dark:text-gray-300"
                                    >
                                        {item.condition == "01"
                                            ? ""
                                            : item.condition == "02"
                                              ? "RECIBIDO"
                                              : "GENERADO"}
                                    </label>
                                </div>
                                <div className="mb-3">
                                    <p className="font-semibold text-gray-900 dark:text-white">
                                        {item.productName}
                                    </p>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">
                                        SKU: {item.sku} • {item.unitName}
                                    </p>
                                </div>
                                <div className="grid grid-cols-2 gap-3 mb-3">
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Precio
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            {Number(item.price)}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Cant. Ordenada
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            {item.quantityOrdered}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Cant. Recibida
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            {Number(item.quantityReceived)}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Cant. Faltante
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            {missingQty}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Subtotal Ordenado
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            S/{" "}
                                            {Number(item.amountIgv).toFixed(2)}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">
                                            Subtotal Recibido
                                        </p>
                                        <p className="font-medium text-gray-900 dark:text-white">
                                            S/{" "}
                                            {calculateSubtotal(
                                                item,
                                                item.quantity,
                                            ).toFixed(2)}
                                        </p>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1">
                                        Cantidad a Recibir
                                    </label>
                                    <input
                                        type="number"
                                        className={`${inputClass} text-center`}
                                        name="quantity"
                                        onFocus={(e) => e.target.select()}
                                        onWheel={(e) => e.target.blur()}
                                        autoComplete="off"
                                        readOnly={
                                            item.condition == "03"
                                                ? true
                                                : false
                                        }
                                        value={item.quantity}
                                        onChange={(e) => {
                                            if (
                                                Number(e.target.value) >
                                                Number(item.quantityOrdered) -
                                                    Number(
                                                        item.quantityReceived,
                                                    )
                                            ) {
                                                return false;
                                            } else if (
                                                Number(e.target.value) == 0
                                            ) {
                                                setOrder({
                                                    ...order,
                                                    operationItems:
                                                        order.operationItems.map(
                                                            (o) => {
                                                                if (
                                                                    o.operationDetailID ==
                                                                    item.operationDetailID
                                                                ) {
                                                                    o.quantity =
                                                                        e.target.value;
                                                                    o.condition =
                                                                        "01";
                                                                }
                                                                return o;
                                                            },
                                                        ),
                                                });
                                            } else {
                                                setOrder({
                                                    ...order,
                                                    operationItems:
                                                        order.operationItems.map(
                                                            (o) => {
                                                                if (
                                                                    o.operationDetailID ==
                                                                    item.operationDetailID
                                                                ) {
                                                                    o.quantity =
                                                                        e.target.value;
                                                                    o.condition =
                                                                        "02";
                                                                }
                                                                return o;
                                                            },
                                                        ),
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1">
                                        Fecha Vencimiento
                                    </label>
                                    <input
                                        type="date"
                                        name="expireDate"
                                        className={inputClass}
                                        value={item.expireDate}
                                        onChange={(e) => {
                                            setOrder({
                                                ...order,
                                                operationItems:
                                                    order.operationItems.map(
                                                        (o) => {
                                                            if (
                                                                o.operationDetailID ==
                                                                item.operationDetailID
                                                            ) {
                                                                o.expireDate =
                                                                    e.target.value;
                                                            }
                                                            return o;
                                                        },
                                                    ),
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        );
                    })}
                    {/* Mobile Totals */}
                    <div className="p-4 bg-gray-50 dark:bg-gray-700/50 space-y-2">
                        <div className="flex justify-between">
                            <span className="font-semibold text-gray-700 dark:text-gray-300">
                                Total Ordenado
                            </span>
                            <span className="font-bold text-gray-900 dark:text-white">
                                S/ {totalOrdered}
                            </span>
                        </div>
                        <div className="flex justify-between">
                            <span className="font-semibold text-gray-700 dark:text-gray-300">
                                Total Recibido
                            </span>
                            <span className="font-bold text-gray-900 dark:text-white">
                                S/ {totalReceived}
                            </span>
                        </div>
                        <div className="flex justify-between">
                            <span className="font-semibold text-gray-700 dark:text-gray-300">
                                Total Faltante
                            </span>
                            <span className="font-bold text-gray-900 dark:text-white">
                                S/ {totalMissing}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 justify-between items-start sm:items-center">
                <div className="flex flex-wrap gap-3">
                    <Link
                        to="/buys/new_purchase_order"
                        className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    >
                        <i className="fas fa-plus"></i> Nuevo
                    </Link>
                    <Link
                        to="/buys/purchase_orders_issued"
                        className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
                    >
                        <i className="fas fa-list"></i> Orden de Compras
                    </Link>
                </div>
                <button
                    type="button"
                    className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                    onClick={handleSubmit}
                >
                    Generar compra
                </button>
            </div>
        </>
    );
}
